<template>
  <div class="module_page page_content institution" aria-label="Self Registration Configuration Page">
    <div class="hidden-container">
      <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
        <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
      </form>
    </div>
    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">Self Registration Configuration</label>
      </div>
      <div class="col-4 btn_container">
        <template v-if="isEditClicked">
          <b-btn @click="doneClicked">done</b-btn>
          <b-btn class="btn-cancel" @click="cancelClicked" title="Cancel"><span class="icon-cross"></span></b-btn>
        </template>
        <template v-else>
          <b-btn @click="isEditClicked = true">edit</b-btn>
        </template>
      </div>
    </div>
    <div class="page_content_container">
      <div class="row pg_content">
        <div class="col-12">
          <div class="row">
            <div class="col-12 pg_fld_sec">
              <template v-if="isEditClicked">
                <div class="row pg_fld_row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Short Name</label>
                        </div>
                        <div class="fld_input">
                          <b-form-input v-model.trim="shortName" @input="forceLowerCase($event, 'shortName')" @keydown.space.prevent style="height: 24px !important;" :state="shortNameState" aria-describedby="shortNameFeedback"></b-form-input>
                          <b-form-invalid-feedback id="shortNameFeedback">
                            Short Name can not left blank
                          </b-form-invalid-feedback>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 30px;">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Welcome Text</label>
                        </div>
                        <div class="fld_input">
                          <editor api-key="no-api-key"
                            v-model.trim="customText"
                            :init="({
                              base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                              menubar: false,
                              plugins: plugins,
                              toolbar: toolbar,
                              branding: false,
                              statusbar: false,
                              end_container_on_empty_block: true
                            })"
                            @onInit="handlerInit"
                            id="selfRegistrationCustomTextId">
                          </editor>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Header Logo</label>
                        </div>
                        <div class="fld_input">
                          <div class="thumbnail_container" style="height: 270px;">
                            <btn v-if="!showAddThumbnailModal" class="btn" @click="addThumbnailClicked">upload logo</btn>
                            <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri" class="thumbnail_image">
                            <span v-else class="ic ico-buildingCollege"></span>
                          </div>
                          <b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
                            <div slot="modal-header" class="popover-header">
                              <div class="popup-heading">Update Thumbnail</div>
                              <button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
                              <span class="ic-close"></span>
                              </button>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <div class="thumbnail_msg">How your logo will appear</div>
                                <div class="thumbnail_container">
                                  <b-btn v-if="isUploadingThumbnail || (logo && logo.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove logo</b-btn>
                                  <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri">
                                  <span v-else class="ic ico-buildingCollege"></span>
                                </div>
                                <span v-if="!showPreview">Preview unavailable</span>
                              </div>
                              <div class="col-7 right-model-box">
                                <div class="row fld_row">
                                  <div class="col-1 fld_col_label">
                                    <label>URL</label>
                                  </div>
                                  <div class="col-8 fld_col_input">
                                    <input :disabled="isUploadingThumbnail" v-model="logoUri" placeholder="http://"></input>
                                  </div>
                                  <div class="col-3 btn_container">
                                  </div>
                                </div>
                                <div class="row fld_row msg_row">
                                  <div class="col-1"></div>
                                  <div class="col-11 msg">Add image url for logo.</div>
                                </div>
                                <div class="row txt_sep_row">
                                  <div class="col-12">OR</div>
                                </div>
                                <div class="row fld_row">
                                  <div class="col-1 fld_col_label">
                                    <label for="newThumbnailFileName">File</label>
                                  </div>
                                  <div class="col-8 fld_col_input">
                                    <input id="newThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer"></input>
                                  </div>
                                  <div class="col-3 fld_col_btn">
                                    <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
                                  </div>
                                </div>
                                <div class="row msg_row">
                                  <div class="col-1"></div>
                                  <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
                                </div>
                              </div>
                            </div>
                            <div slot="modal-footer">
                              <b-btn @click="addNewThumbnail">save and next</b-btn>
                              <b-btn @click="cancelAddThumbnail">cancel</b-btn>
                            </div>
                          </b-modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pg_fld_row">
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="primaryColorValue" @input="updatePrimaryColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Text Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="secondaryColorValue" @input="updateSecondaryColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Hover Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="buttonHoverColorValue" @input="updateButtonHoverColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Link Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="linkColorValue" @input="updateLinkColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Link Hover Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="linkHoverColorValue" @input="updateLinkHoverColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Other Text Color</label>
                        </div>
                        <div class="fld_input">
                          <chrome-picker :value="backgroundColorValue" @input="updateBackgroundColor"></chrome-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pg_fld_row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Text Font</label>
                        </div>
                        <div class="fld_input">
                          <font-picker :api-key="apiKey" :active-font="activeFont" :options="{name: 'srf'}"
                            categories="['sans-serif', 'serif', 'display']" @change="updateFontFamily"></font-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row pg_fld_row">
                  <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label" for="shortName">Short Name</label>
                        </div>
                        <div class="fld_input">
                          <label class="val">{{shortName}}</label>
                        </div>
                        <div class="fld_input" v-if="shortName">
                          <span class="val"><small> Self Registration Link : {{selfRegistrationLink}}</small></span>
                        </div>
                        <div class="fld_input" v-if="shortName">
                          <span class="val"> <small>Signin Link :  {{selfSigninLink}}</small></span>
                        </div>

                      </div>
                    </div>
                    <div class="row" style="margin-top: 30px;">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Welcome Text</label>
                        </div>
                        <div class="fld_input">
                          <div class="text-area p-2" v-html="customText"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Header Logo</label>
                        </div>
                        <div class="fld_input">
                          <div class="thumbnail_container" style="height: 270px; width: 270px;">
                            <img v-if="logo" id="institutionThumbnail" class="thumbnail_image" :src="logo" />
                            <span v-else class="ic ico-buildingCollege"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pg_fld_row">
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="primaryColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: primaryColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="secondaryColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Text Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: secondaryColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="buttonHoverColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Button Hover Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: buttonHoverColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="linkColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Link Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: linkColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="linkHoverColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Link Hover Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: linkHoverColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="backgroundColor">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Other Text Color</label>
                        </div>
                        <div class="fld_input">
                          <label class="color-value" :style="{background: backgroundColor}"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6" v-if="fontFamily">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Text Font</label>
                        </div>
                        <div class="fld_input apply-font-srf">
                          <label class="val" style="font-size: 24px;">{{fontFamily}}</label>
                        </div>
                        <div class="fld_input d-none">
                          <font-picker :api-key="apiKey" :active-font="activeFont" :options="{name: 'srf'}"></font-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global AWS:true */
  import Vue from 'vue'
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import { AwsObject } from '../../institution/aws'
  import { Chrome } from 'vue-color'
  import Vuelidate from 'vuelidate'
  import FontPicker from 'font-picker-vue'
  import {required} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.use(FontPicker)

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'selfRegistrationConfiguration',
    props: ['uuid'],
    components: {
      Editor,
      'chrome-picker': Chrome,
      'font-picker': FontPicker
    },
    data: () => {
      return {
        logo: '',
        logoCopy: '',
        logoUri: '',
        logoUriCopy: '',
        shortName: null,
        customText: null,
        primaryColor: null,
        secondaryColor: null,
        backgroundColor: null,
        buttonHoverColor: null,
        linkColor: null,
        linkHoverColor: null,
        fontFamily: null,
        activeFont: 'Open Sans',
        plugins: 'lists  autolink charmap code hr link textcolor',
        toolbar: 'bold italic | fontsizeselect | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink',
        isEditClicked: false,
        showPreview: true,
        isEditingThumbnail: false,
        showAddThumbnailModal: false,
        apiKey: 'AIzaSyAa3D-xZhJGxFRI2cxDX6iInTwA4hKy3pc'
      }
    },
    validations: {
      shortName: {
        required
      }
    },
    mounted () {
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
      this.loadConfiguration()
    },
    methods: {
      ...mapActions([
        'loadCurrentEnvironment',
        'uploadContentAndGetUri',
        'loadSelfRegistrationConfiguration',
        'storeSelfRegistrationConfiguration',
        'updateFileUriAndVersionIdAfterS3Upload'
      ]),
      showLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.hide()
        }
      },
      handlerInit (ev, editor) {
        $('#selfRegistrationCustomTextId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
      },
      forceLowerCase (e, prop) {
        e = e.replace(' ', '').toLowerCase()
        this.$set(this.$data, prop, e)
      },
      loadConfiguration () {
        this.loadSelfRegistrationConfiguration(this.uuid).then(configuration => {
          this.isEditClicked = false
          this.logo = configuration.logo
          this.logoUri = configuration.logo
          this.shortName = configuration.shortName
          this.customText = configuration.customText
          this.fontFamily = configuration.fontFamily
          this.primaryColor = configuration.primaryColor
          this.secondaryColor = configuration.secondaryColor
          this.backgroundColor = configuration.backgroundColor
          this.buttonHoverColor = configuration.buttonHoverColor
          this.linkColor = configuration.linkColor
          this.linkHoverColor = configuration.linkHoverColor
          if (this.fontFamily) {
            this.activeFont = this.fontFamily
          } else {
            this.activeFont = 'Open Sans'
          }
        })
      },
      cancelClicked () {
        this.loadConfiguration()
      },
      doneClicked () {
        this.onSubmit(true)
      },
      addThumbnailClicked () {
        this.showAddThumbnailModal = true
        this.isEditingThumbnail = true
        this.logoUriCopy = this.logoUri.slice(0)
        this.logoCopy = this.logo.slice(0)
      },
      removeThumbnailClicked () {
        this.isEditingThumbnail = true
        this.showPreview = true
        this.logo = ''
        this.logoUri = ''
      },
      cancelAddThumbnail () {
        this.logo = this.logoCopy
        this.logoUri = this.logoUriCopy
        this.isEditingThumbnail = false
        this.showAddThumbnailModal = false
        this.errors = []
        this.fileUploadArray = []
      },
      addNewThumbnail () {
        if (this.logo !== this.logoUri) {
          // user entered url instead of uploading local file, no upload necessary
          this.logo = this.logoUri
        } else {
          this.uploadFiles()
        }
        this.showAddThumbnailModal = false
        this.isEditingThumbnail = false
      },
      chooseFile () {
        $('input[type=file][id=thumbnailFileList]').click()
      },
      thumbnailToBeUploaded (ev) {
        this.fileUploadArray = []
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length || files.length <= 0) {
          return
        }
        this.logoUri = files[0].name
        this.logo = files[0].name
        this.prepareFileUploadArray(files)
        this.showPreview = false
      },
      prepareFileUploadArray (files) {
        if (!files || files.length === 0) {
          return
        }
        let timestamp = new Date().getTime()
        for (var i = 0; i < files.length; i++) {
          timestamp = timestamp + i
          this.addFileToUploadArray(files[i], timestamp)
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        let isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
      },
      uploadFiles () {
        let contentListToCreate = []
        let fileUploadArrayClone = clone(this.fileUploadArray)
        _.forEach(fileUploadArrayClone, (content) => {
          let item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'logo': content.logo,
            'logoUri': content.logoUri
          }
          contentListToCreate.push(item)
        })
        if (contentListToCreate.length <= 0) {
          return
        }
        this.showLoader()
        this.uploadContentAndGetUri({
          learningSpaceId: this.uuid,
          contents: contentListToCreate,
          success: this.uploadFileAfterCreateContentSuccessCallback,
          failure: this.uploadFileAfterCreateContentErrorCallback
        })
      },
      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.fileUploadArray = []
        this.showPreview = true
        this.showSuccessPopup()
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
        this.hideLoader()
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        }
      },
      storeFilesToS3 (filesToBeUploaded) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
            } else {
              var uri = item.uri
              if (uri.indexOf('?versionId=') === -1) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
            }
            let logoData = filesToBeUploaded[0]
            this.logoUri = logoData.uri
            this.logo = logoData.uri
            this.hideLoader()
          })
        })
      },
      showSuccessPopup () {
        console.log('file upload successful!')
      },
      updatePrimaryColor (colors) {
        this.primaryColor = colors.hex
      },
      updateSecondaryColor (colors) {
        this.secondaryColor = colors.hex
      },
      updateBackgroundColor (colors) {
        this.backgroundColor = colors.hex
      },
      updateButtonHoverColor (colors) {
        this.buttonHoverColor = colors.hex
      },
      updateLinkColor (colors) {
        this.linkColor = colors.hex
      },
      updateLinkHoverColor (colors) {
        this.linkHoverColor = colors.hex
      },
      updateFontFamily (font) {
        this.activeFont = font.family
        this.fontFamily = font.family
      },
      onSubmit (isDone) {
        this.$v.shortName.$touch()
        if (!this.$v.shortName.$error) {
          this.showLoader()
          let data = {
            logo: this.logo,
            shortName: this.shortName,
            customText: this.customText,
            fontFamily: this.fontFamily,
            primaryColor: this.primaryColor,
            secondaryColor: this.secondaryColor,
            backgroundColor: this.backgroundColor,
            buttonHoverColor: this.buttonHoverColor,
            linkColor: this.linkColor,
            linkHoverColor: this. linkHoverColor,
            registrationLink: this.selfRegistrationLink
          }
          this.storeSelfRegistrationConfiguration({uuid: this.uuid, data: data}).then(response => {
            this.hideLoader()
            let status = response.status
            if (status === 200) {
              let message = 'Self Registration Configuration updated successfully.'
              this.notifySuccess(message)
            } else {
              let message = 'Unable to update Self Registration Configuration'
              if (response.status === 409) {
                message = 'Short Name is already in use.'
              }
              this.notifyFailure(message)
            }
            if (isDone) {
              this.loadConfiguration()
            }
          })
        }
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'currentEnvironment': state => state.learningContent.currentEnvironment
      }),
      shortNameState () {
        return this.$v.shortName.$error ? false : null
      },
      primaryColorValue () {
        return this.primaryColor || '#157099'
      },
      secondaryColorValue () {
        return this.secondaryColor || '#FFFFFF'
      },
      backgroundColorValue () {
        return this.backgroundColor || '#000000'
      },
      buttonHoverColorValue () {
        return this.buttonHoverColor || '#157099'
      },
      linkColorValue () {
        return this.linkColor || '#157099'
      },
      linkHoverColorValue () {
        return this.linkHoverColor || '#157099'
      },
      selfSigninLink() {
        if (this.shortName) {
          return window.location.origin + '/signin/' + this.shortName
        }
        return ''
      },
      selfRegistrationLink () {
        if (this.shortName) {
          return window.location.origin + '/signup/' + this.shortName
        }
        return ''
      }
    }
  }
</script>

<style>
  .text-area {
    height: 125px !important;
    overflow: scroll;
    margin-left: 10px;
  }
  .vc-chrome-toggle-btn {
    display: none !important;
  }
  .color-value {
    width: 140px;
    height: 60px;
    border-radius: 5px;
    margin-left: 10px;
  }
</style>
<style scoped>
.hidden-container {
  visibility: hidden;
  height: 1px;
}
</style>


// WEBPACK FOOTER //
// src/app/dashboard/components/SelfRegistrationConfiguration.vue